import { LoadingDialog } from '@/components/controls';
import { NoticeEditorDialog } from './NoticeEditorDialog';
import { useDeleteNotice } from './useDeleteNotice';
import { useNotice } from './useNotice';
import { useUpsertNotice } from './useUpsertNotice';

export function NoticeEditor({ code, isOpen, onClose, groupCodes }) {
  const {
    query: { data: notice },
  } = useNotice(code, {
    groupCodes: groupCodes ?? [],
    title: '',
    nominalIds: [],
    contentHTML: '',
  });
  const { mutate: upsertNotice } = useUpsertNotice();
  const { mutate: deleteNotice } = useDeleteNotice();

  function handleClose(values) {
    if (values) {
      upsertNotice(values);
    }

    onClose();
  }

  function handleDelete() {
    deleteNotice(code);

    onClose();
  }

  return notice ? (
    <NoticeEditorDialog
      notice={notice}
      isOpen={isOpen}
      onClose={handleClose}
      onDelete={handleDelete}
    />
  ) : (
    <LoadingDialog isOpen={isOpen} />
  );
}
